// Module
var code = "<modal title=\"{{ $ctrl.title || ('Info' | translate) }}\" save=$hide() save-text=\"{{ 'OK' | translate }}\"> {{ $ctrl.message }} </modal> ";
// Exports
module.exports = code;